/**
 * Chaves do TanStack Query, do GERAL para o ESPECÍFICO.
 *
 * Essa ordem é o que permite invalidar em bloco: um
 * `invalidateQueries({ queryKey: chaves.produtos.raiz })` derruba vitrine,
 * catálogo e detalhe numa chamada só.
 */
import type { FiltrosVitrine } from './produtos.js'

export const chaves = {
  auth: { sessao: ['auth', 'sessao'] as const },

  config: { loja: ['config', 'loja'] as const },

  admin: {
    raiz: ['admin'] as const,
    produtos: ['admin', 'produtos'] as const,
    resumo: ['admin', 'resumo'] as const,
    produto: (id: string) => ['admin', 'produtos', 'item', id] as const,
  },

  produtos: {
    raiz: ['produtos'] as const,
    vitrine: (condicao: 'NOVA' | 'USADA') => ['produtos', 'vitrine', condicao] as const,
    catalogo: (filtros: FiltrosVitrine) => ['produtos', 'catalogo', filtros] as const,
    detalhe: (slug: string) => ['produtos', 'detalhe', slug] as const,
  },

  filtros: { disponiveis: ['filtros'] as const },
} as const
